module.exports = {"name":"New Endpoints","release":"2017-10-03","__content":"<!--\n    This section contains the content of the log. You can use markdown here.\n\n    Please don't use heading markup as it clashes with the rest of the page.\n    If you absolutely HAVE to, please use #### Heading 4 or above.\n-->\n<ul>\n<li>Added new <a href=\"/api/Registration#post-manage-preregister-invite\">Manage Invitation endpoints</a> to send invitations to pre-registered users.</li>\n<li>Added new endpoint to <a href=\"/api/Targets#post-manage-targets-\">create new Target values</a>. </li>\n</ul>\n"}


//////////////////
// WEBPACK FOOTER
// ./src/changelog/logs/2017-10-03_Test.md
// module id = 661
// module chunks = 1